import React, { Component } from 'react';
import StatusTable from './status-table.js';
import StoreFilter from './store-filter';
import DateFilter from './date-filter';
import Request from 'superagent';
import classnames from 'classnames';

export default class App extends Component {
  constructor(props) {
    super(props);
    const secondsInOneDay = 60 * 60 * 24;

    this.state = {
        statuses: [],
        stores: [],
        activeStoreFilter: null,
        dateRanges: [
          {
            name: "Last 24 Hours",
            value: secondsInOneDay
          },
          {
            name: "Last 7 Days",
            value: secondsInOneDay * 7
          },
          {
            name: "Last 30 Days",
            value: secondsInOneDay * 30
          }
        ],
        activeDateRangeFilter: secondsInOneDay,
        isFetching: true
    };
  }
  getActiveStoreName() {
    let filteredStores = this.state.stores.filter((store) => {
      return store.dms_id === this.state.activeStoreFilter;
    });
    return filteredStores.length ? filteredStores[0].dms_label : '';
  }
  getActiveDateRangeName() {
    let filteredDateRanges = this.state.dateRanges.filter((dateRange) => {
      return dateRange.value === +this.state.activeDateRangeFilter;
    });
    return filteredDateRanges.length ? filteredDateRanges[0].name : '';
  }
  componentDidMount() {
    this.fetchStores().then((stores) => {
      this.setState(
        {
          stores: stores,
          activeStoreFilter: stores[0].dms_id
        }
      );
    }).then(() => {
      return this.fetchStatuses(this.state.activeStoreFilter, this.state.activeDateRangeFilter);
    }).then((statuses) => {
      this.setState(
        {
          statuses: statuses,
          isFetching: false
        }
      );
    });
  }
  onStoreChange(store) {
    this.setState({isFetching: true});
    this.fetchStatuses(store, this.state.activeDateRangeFilter).then((statuses) => {
      this.setState(
        {
          activeStoreFilter: store,
          statuses: statuses,
          isFetching: false
        }
      );
    });
  }
  onDateRangeChange(dateRange) {
    this.setState({isFetching: true});
    this.fetchStatuses(this.state.activeStoreFilter, dateRange).then((statuses) => {
      this.setState(
        {
          activeDateRangeFilter: dateRange,
          statuses: statuses,
          isFetching: false
        }
      );
    });
  }
  fetchStores() {
    return new Promise((resolve, reject) => {
      Request.get('/api/stores')
        .end((error, response) => {
          error ? reject(error) : resolve(response.body.data.stores);
      });
    });
  }
  fetchStatuses(activeStoreFilter, activeDateRangeFilter) {
    return new Promise((resolve, reject) => {
      Request.get('/api/metrics')
        .query({dms_ids: activeStoreFilter})
        .query({start_back: activeDateRangeFilter})
        .query({end_back: 0})
        .query({aggr: "cnt,avg,min,max"})
        .end((error, response) => {
          let stores = response.body.data.stores;
          error ? reject(error) : resolve((stores && stores.length) ? stores[0].statuses : []);
      });
    });
  }
  render() {
    const loadingClasses = classnames('loading-overlay', 'text-center', {
        hidden: !this.state.isFetching
    });

    return (
        <div>
            <div className={loadingClasses}>
                <div className="loading-icon">
                    <img src="/static/img/ring-alt.svg" />
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-md-4">
                        <StoreFilter
                          stores={this.state.stores}
                          activeStoreFilter={this.state.activeStoreFilter}
                          onStoreChange={this.onStoreChange.bind(this)}
                        />
                    </div>
                    <div className="col-md-4" />
                    <div className="col-md-4">
                        <DateFilter
                          dateRanges={this.state.dateRanges}
                          activeDateRangeFilter={this.state.activeDateRangeFilter}
                          onDateRangeChange={this.onDateRangeChange.bind(this)}
                        />
                    </div>
                </div>
                <div className="row">
                  {
                    <StatusTable
                      statuses={this.state.statuses}
                      storeName={this.getActiveStoreName()}
                      dateRangeName={this.getActiveDateRangeName()}
                    />
                  }
                </div>
            </div>
        </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/